module.exports = "/_next/static/images/1c4c806077f1d0d2184c1cbc5829780d-ticket-01-01.png";